
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Defer only lightweight preloaders - NOT Stripe (loaded on payment page only)
if (typeof window !== 'undefined') {
  const loadDeferredModules = () => {
    import('./utils/taggboxEarlyPreloader');
  };

  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(loadDeferredModules);
  } else {
    setTimeout(loadDeferredModules, 3000);
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
